import { IPreferences } from "@/androidPlugins/IPreferences"

const CARDHOLDER_NOT_PRESENT_PREFERENCE_KEY =
  "cardholderNotPresentEnabled"

const _cardholderNotPresentEnabledPreference = ref<
  boolean | undefined
>()

const hydrateCardholderNotPresentEnabled = async () => {
  const { value } = await IPreferences.get({
    key: CARDHOLDER_NOT_PRESENT_PREFERENCE_KEY,
  })

  _cardholderNotPresentEnabledPreference.value =
    value === null ? false : JSON.parse(value)
}

const cardholderNotPresentEnabled = computed({
  get: () =>
    _cardholderNotPresentEnabledPreference.value ?? false,
  set: async (value: boolean) => {
    _cardholderNotPresentEnabledPreference.value = value

    await IPreferences.set({
      key: CARDHOLDER_NOT_PRESENT_PREFERENCE_KEY,
      value: JSON.stringify(
        _cardholderNotPresentEnabledPreference.value
      ),
    })
  },
})

export const useCardholderNotPresent = () => {
  if (
    _cardholderNotPresentEnabledPreference.value ===
    undefined
  ) {
    hydrateCardholderNotPresentEnabled()
  }

  return {
    cardholderNotPresentEnabled,
  }
}
